import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const CATALOG_PERMISSIONS = {
  MODERATE: PERMISSIONS.CATALOG_MODERATE,
};

export const CATALOG_QUERY_KEYS = queryKeys.catalog;

export const MODERATION_DECISION = {
  APPROVE: 'APPROVE',
  HIDE: 'HIDE',
  REQUEST_CHANGES: 'REQUEST_CHANGES',
};
